import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as ToastPrimitive from '@radix-ui/react-toast';
import { CheckCircle, AlertTriangle, XCircle, Info } from 'lucide-react';
import { cn } from '../../lib/cn.js';
const iconMap = {
    success: CheckCircle,
    warning: AlertTriangle,
    error: XCircle,
    info: Info,
};
const colorMap = {
    success: 'text-success',
    warning: 'text-warning',
    error: 'text-destructive',
    info: 'text-info',
};
const ToastContext = React.createContext(null);
export function ToastProvider({ children }) {
    const [items, setItems] = React.useState([]);
    const idRef = React.useRef(0);
    const show = React.useCallback((args) => {
        setItems((prev) => [...prev, { ...args, id: ++idRef.current }]);
    }, []);
    return (_jsx(ToastContext.Provider, { value: { show }, children: _jsxs(ToastPrimitive.Provider, { duration: 4000, children: [children, items.map((t) => {
                    const Icon = iconMap[t.status];
                    return (_jsxs(ToastPrimitive.Root, { duration: t.duration ?? 4000, onOpenChange: (open) => !open && setItems((prev) => prev.filter((i) => i.id !== t.id)), className: cn('bg-secondary border border-border rounded-md p-4 shadow-lg', 'flex items-start gap-3', 'data-[state=open]:animate-in data-[state=closed]:animate-out'), children: [_jsx(Icon, { size: 20, className: colorMap[t.status], "aria-hidden": "true" }), _jsxs("div", { className: "flex-1 min-w-0", children: [_jsx(ToastPrimitive.Title, { className: "font-semibold text-sm", children: t.title }), t.description && (_jsx(ToastPrimitive.Description, { className: "text-sm text-foreground/70 mt-1", children: t.description }))] })] }, t.id));
                }), _jsx(ToastPrimitive.Viewport, { className: "fixed bottom-4 right-4 z-toast flex flex-col gap-2 w-96 outline-none" })] }) }));
}
export function useToast() {
    const ctx = React.useContext(ToastContext);
    if (!ctx)
        throw new Error('useToast must be used inside <ToastProvider>');
    return ctx;
}
//# sourceMappingURL=ToastProvider.js.map